import React from 'react';
import styles from '../../styles/proxy-server.module.scss';
import {Button, Divider, Input, Checkbox, message, Modal, Select, Icon, Table, Tag, Row, Col} from 'antd';
import WebServerRestClient from "../../tools/WebServerRestClient";
import UserComponent from "../../components/UserComponent";
import CommonUtils from "../../tools/CommonUtils";

const uuidv4 = require('uuid/v4');
const { confirm } = Modal;
const { Option } = Select;

const COST_TIER_STANDARD = 2;
const costTierList = [
    {value: 1, label: 'Cheap', color: 'green'},
    {value: 2, label: 'Standard', color: 'blue'},
    {value: 3, label: 'Premium', color: 'gold'}
];

const modifyProxyServerFields = [
    'addFlag',
    'id',
    'networkType',
    'provider',
    'continent_code',
    'country_code',
    'country_name',
    'location',
    'costTier',
    'host',
    'nh_port',
    'vthreads',
    'deny_country_list',
    'offered_protocols',
    'remarks',
    'ps_host',
    'ps_port',
    'ps_password',
    'ps_encryption',
    'trojan_domain',
    'trojan_port',
    'trojan_password',
    'trojan_remote_addr',
    'trojan_remote_port',
    'trojan_encryption_method',
    'trojan_encryption_password',
    'vless_port',
    'vless_uuid',
    'vless_server_name',
    'vless_reality_private_key',
    'vless_reality_public_key',
    'vless_reality_short_id'
];

export default class ProxyServerList extends UserComponent {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            showEditModal: false,
            showServerDetailDialog: false,
            showBatchUpdateModal: false,
            showCreateGroupModal: false,
            showUpdateVthreadsModal: false,
            showMessageDialog: false,
            showConfirmModal: false,
            confirmLoading: false,
            totalCount: 0,
            selectedCount: 0,
            proxyServerConfig: {},
            groupList:[],
            providers: [],
            networkTypeList:[],
            serverStatusList:[],
            selectedRow: {},
            serverLocationList: [],
            selectedRowKeys: '',
            query_params: {},
            form_params: {},
            batch_update_params: {
                ids: [],
                status: '',
                groupName: ''
            }
        }
    }

    componentDidMount() {
        this.loadListData();
        this.loadGroupList();
        this.loadServerLocationList();
        this.loadProxyServerConfig();
        this.loadProxyServerStatusList();
        this.loadNetworkTypeList();
    }

    handleQueryInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        let query_params = this.state.query_params;
        query_params[name] = value;
        this.setState(query_params);
    }

    setStateParams(params, name, value) {
        params[name] = value;
        this.setState(params);
    }

    handleQuerySelectChange(name,value) {
        let query_params = this.state.query_params;
        query_params[name] = value;
        this.setState(query_params);
    }

    handleFormInputChange(event) {
        const target = event.target;
        const name = target.name;
        let value = target.type === 'checkbox' ? target.checked : target.value;
        if (name !== 'remarks') {
            value = value.trim();
        }
        let form_params = this.state.form_params;
        form_params[name] = value;
        if (name === 'trojan_domain' && this.isEmptyFormValue(form_params.vless_server_name)) {
            form_params.vless_server_name = value;
        }
        this.setState(form_params);
    }

    handleFormSelectChange(name,value) {
        let form_params = this.state.form_params;
        form_params[name] = value;
        this.setState(form_params);
    }

    normalizeCostTier(value) {
        if (typeof value === 'undefined' || value === null || value === '') {
            return COST_TIER_STANDARD;
        }
        let costTier = Number(value);
        return isNaN(costTier) ? COST_TIER_STANDARD : costTier;
    }

    getCostTierOption(value) {
        let costTier = this.normalizeCostTier(value);
        return costTierList.find(item => item.value === costTier) || {
            value: costTier,
            label: costTier,
            color: 'default'
        };
    }

    renderCostTier(value) {
        let option = this.getCostTierOption(value);
        return <Tag color={option.color}>{option.label}</Tag>;
    }

    handleInputFocus(event) {
        const target = event.target;
        if (target.type === 'text') {
            this.setState({showMessageDialog: false});
        }
    }

    loadListData() {
        this.setState({loading: true});
        new WebServerRestClient().GET('/admin/query-proxy-server-list', this.state.query_params)
            .then(response => {
                this.setState({loading: false});
                if (response.code === 200) {
                    let totalCount = 0;
                    if (response.data) {
                        totalCount = response.data.length;
                    }
                    this.setState({
                        dataList: response.data,
                        totalCount: totalCount,
                        selectedCount: 0,
                        selectedRowKeys: []
                    })
                } else if (response.code === 401 || response.code === 403) {
                    this.props.history.push('/login');
                } else {
                    message.error(response['msg']);
                }
            }).catch(err => {
            this.setState({loading: false});
            message.error("Error: " + err.message);
        });
    }

    loadServerLocationList() {
        new WebServerRestClient().GET('/open/server-location/available-list')
            .then(response => {
                console.debug("server-location/available-list response -> " + JSON.stringify(response.data));
                if (response.code === 200) {
                    this.setState({serverLocationList: response.data})
                } else if (response.code === 401 || response.code === 403) {
                    this.props.history.push('/login');
                } else {
                    message.error(response['msg']);
                }
            }).catch(err => {
            console.error(err);
            message.error("Error: " + err.message);
        });
    }

    loadGroupList = () => {
        this.setState({loading: true});
        new WebServerRestClient().GET('/admin/proxy-group-list')
            .then(response => {
                console.log("load proxy-group-list response -> " + JSON.stringify(response));
                if (response.code === 200) {
                    this.setState({groupList: response.data, loading: false});
                } else if (response.code === 401 || response.code === 403) {
                    this.props.history.push('/login');
                } else {
                    message.error(response['msg']);
                }
            }).catch(err => {
            console.error(err);
            message.error("Error: " + err.message);
        });
    };

    loadCountryDetail(countryCode) {
        new WebServerRestClient().GET('/admin/server-location/' + countryCode)
            .then(response => {
                console.debug("load country detail response -> " + JSON.stringify(response));
                if (response.code === 200) {
                    this.handleFormSelectChange('continent_code',response.data.continentCode);
                    this.handleFormSelectChange('country_name',response.data.countryName);
                    this.handleFormSelectChange('country_code',response.data.countryCode);
                    this.handleFormSelectChange('location',response.data.location);
                    this.setState({loading: false})
                } else if (response.code === 401 || response.code === 403) {
                    this.props.history.push('/login');
                } else {
                    message.error(response['msg']);
                }
            }).catch(err => {
            console.error(err);
            message.error("Error: " + err.message);
        });
    }

    loadProxyServerConfig() {
        new WebServerRestClient().GET('/admin/dict/proxy-server-config')
            .then(response => {
                console.debug("load proxy-server-config response -> " + JSON.stringify(response));
                if (response.code === 200) {
                    this.setState({
                        form_params: response.data,
                        proxyServerConfig: response.data,
                        providers: response.data.providers
                    })
                } else if (response.code === 401 || response.code === 403) {
                    this.props.history.push('/login');
                } else {
                    message.error(response['msg']);
                }
            }).catch(err => {
            console.error(err);
            message.error("Error: " + err.message);
        });
    }

    loadProxyServerStatusList() {
        new WebServerRestClient().GET('/admin/dict/proxy-server-status')
            .then(response => {
                console.debug("load proxy-server-status response -> " + JSON.stringify(response));
                if (response.code === 200) {
                    this.setState({serverStatusList: response.data})
                } else if (response.code === 401 || response.code === 403) {
                    this.props.history.push('/login');
                } else {
                    message.error(response['msg']);
                }
            }).catch(err => {
            console.error(err);
            message.error("Error: " + err.message);
        });
    }

    loadNetworkTypeList() {
        new WebServerRestClient().GET('/admin/dict/network-types')
            .then(response => {
                console.log("load network-types response -> " + JSON.stringify(response));
                if (response.code === 200) {
                    this.setState({networkTypeList: response.data})
                } else if (response.code === 401 || response.code === 403) {
                    this.props.history.push('/login');
                } else {
                    message.error(response['msg']);
                }
            }).catch(err => {
            console.error(err);
            message.error("Error: " + err.message);
        });
    }

    render() {
        const { selectedRowKeys } = this.state;

        const rowSelection = {
            selectedRowKeys,
            onChange: (selectedRowKeys, selectedRows) => {
                this.setState({selectedRowKeys: selectedRowKeys, selectedCount: selectedRows.length})
            }
        };

        return (
            <div className="container">
                <div className="toolbar">
                    <Input name="host" placeholder="host address" className="search_input"
                           onChange={this.handleQueryInputChange.bind(this)}/>
                    <Divider type="vertical"/>
                    <Input name="trojan_domain" placeholder="trojan domain" className="search_input"
                           onChange={this.handleQueryInputChange.bind(this)}/>
                    <Divider type="vertical"/>
                    <Select style={{width: 150}}
                            placeholder="select network"
                            allowClear={true}
                            showSearch
                            onChange={(value) => this.handleQuerySelectChange('networkType', value)}>
                        {this.state.networkTypeList.map(item => (
                            <Option key={item.value}>{item.key}</Option>
                        ))}
                    </Select>
                    <Divider type="vertical"/>
                    <Select style={{width: 150}}
                            dropdownMatchSelectWidth={false}
                            placeholder="select group"
                            allowClear={true}
                            showSearch
                            onChange={(value) => this.handleQuerySelectChange('groupName', value)}>
                        {this.state.groupList.map(item => (
                            <Option key={item}>{item}</Option>
                        ))}
                    </Select>
                    {/*<Divider type="vertical"/>
                    <Select style={{width: 150}}
                            placeholder="select provider"
                            allowClear={true}
                            onChange={(value) => this.handleQuerySelectChange('provider', value)}>
                        {this.state.providers.map(item => (
                            <Option key={item}>{item}</Option>
                        ))}
                    </Select>*/}
                    <Divider type="vertical"/>
                    <Select style={{width: 150}}
                            placeholder="select country"
                            allowClear={true}
                            showSearch
                            onChange={(value) => this.handleQuerySelectChange('country_code', value)}>
                        {this.state.serverLocationList.map(item => (
                            <Option key={item.countryCode}>{item.countryName}</Option>
                        ))}
                    </Select>
                    <Divider type="vertical"/>
                    <Select style={{width: 150}}
                            placeholder="select protocols"
                            allowClear={true}
                            onChange={(value) => this.handleQuerySelectChange('offered_protocols', value)}>
                        <Option key="ss">Shadowsocks</Option>
                        <Option key="trojan">Trojan</Option>
                        <Option key="trojan-go">Trojan-Go</Option>
                        <Option key="vless">Vless</Option>
                    </Select>
                    <Divider type="vertical"/>
                    <Select style={{width: 150}}
                            placeholder="select status"
                            allowClear={true}
                            onChange={(value) => this.handleQuerySelectChange('status', value)}>
                        {this.state.serverStatusList.map(item => (
                            <Option key={item.value}>{item.key}</Option>
                        ))}
                    </Select>
                    <Divider type="vertical"/>
                    <Button type="primary" icon="search" className="search_btn" loading={this.state.loading}
                            onClick={this.loadListData.bind(this)}>Search</Button>

                </div>

                <div className="button_group">
                    <Button type="link" icon="file-add" size={"small"} onClick={this.startAddNewServer.bind(this)}>New</Button>
                    <Button type="link" icon="edit" size={"small"} onClick={this.startUpdateStatus.bind(this)}>Status</Button>
                    <Button type="link" icon="file-add" size={"small"} onClick={this.startAddNewGroup.bind(this)}>Group</Button>
                    <Button type="link" icon="file-add" size={"small"} onClick={this.startAddNewVthreads.bind(this)}>Vthreads</Button>
                </div>

                <div className="total_bar">
                    <span className="left">
                        Selected <b style={{color:'red'}}>{this.state.selectedCount}</b> Records
                        <Divider type="vertical"/>
                        Total of <b style={{color:'red'}}>{this.state.totalCount}</b> Records
                    </span>
                </div>
                <Table loading={this.state.loading}
                       rowKey={'id'}
                       rowSelection={rowSelection}
                       size={'small'}
                       columns={[
                           {title: 'Group', dataIndex: 'groupName', align: 'left'},
                           {title: 'Continent', dataIndex: 'continent_code', align: 'center'},
                           {title: 'Country', dataIndex: 'country_code', align: 'center'},
                           {title: 'Host', dataIndex: 'host', align: 'center'},
                           {title: 'Domain', dataIndex: 'trojan_domain', align: 'center'},
                           {
                               title: 'Cost Tier',
                               dataIndex: 'costTier',
                               align: 'center',
                               render: (value) => this.renderCostTier(value),
                               sorter: (a, b) => this.normalizeCostTier(a.costTier) - this.normalizeCostTier(b.costTier),
                           },
                           {title: 'Status', dataIndex: 'status', align: 'center',
                               render: (value) => {
                                   if (value === 0) {
                                       return <span style={{color: '#bdb8b8', fontWeight: 'bold', fontSize: 12}}>OFFLINE</span>
                                   } else if (value === 1) {
                                       return <span style={{color: 'green', fontWeight: 'bold', fontSize: 12}}>ACTIVE</span>
                                   } else if (value === 2) {
                                       return <span style={{color: '#ecac0e', fontWeight: 'bold', fontSize: 12}}>PORT-BLOCKED</span>
                                   } else if (value === 3) {
                                       return <span style={{color: '#fd2a7a', fontWeight: 'bold', fontSize: 12}}>IP-BLOCKED</span>
                                   } else if (value === 4) {
                                       return <span style={{color: 'red', fontWeight: 'bold', fontSize: 12}}>DOWN</span>
                                   } else {
                                       return <span style={{color: '#bdb8b8', fontWeight: 'bold', fontSize: 12}}>OFFLINE</span>
                                   }
                               },
                               sorter: (a, b) => a.status - b.status,
                           },
                           {title: 'Protocols', dataIndex: 'offered_protocols', align: 'center'},
                           {
                               title: 'Action',
                               key: 'action',
                               align: 'center',
                               render: (text, record) => (
                                   <span>
                                       <a onClick={() => {
                                           this.setState({
                                               showServerDetailDialog: true,
                                               selectedRow: record
                                           })
                                       }}>View</a>
                                       <Divider type="vertical"/>
                                       <a onClick={() => {
                                           let form_params = Object.assign({}, record);    // copy this selected record data
                                           form_params.addFlag = false; // update flag
                                           form_params.networkType = record.networkType + "";
                                           form_params.costTier = this.normalizeCostTier(record.costTier);

                                           this.setState({
                                               showEditModal: true,
                                               selectedRow: record,
                                               form_params: form_params
                                           });
                                       }}>Modify</a>
                                  </span>
                               ),
                           },
                       ]}
                       dataSource={this.state.dataList}
                       pagination={false}/>

                <Modal
                    title="Batch Update Server Status"
                    visible={this.state.showBatchUpdateModal}
                    onCancel={() => this.setState({showBatchUpdateModal: false})}
                    onOk={() => this.batchUpdateServerStatus()}
                    confirmLoading={this.state.confirmLoading}
                    okText="OK"
                    cancelText="Cancel">
                    <Select className="width_100"
                            placeholder="select one status"
                            allowClear={true}
                            value={this.state.batch_update_params.status}
                            onChange={(value) => this.setStateParams(this.state.batch_update_params, 'status', value)}>
                        {this.state.serverStatusList.map(item => (
                            <Option key={item.value}>{item.key}</Option>
                        ))}
                    </Select>
                </Modal>

                <Modal
                    title="Select Or Create Group"
                    visible={this.state.showCreateGroupModal}
                    onCancel={() => this.setState({showCreateGroupModal: false})}
                    onOk={() => this.addServerToGroup()}
                    confirmLoading={this.state.confirmLoading}
                    okText="OK"
                    cancelText="Cancel">
                    <div style={{height: 300, textAlign: 'center'}}>
                        <Select className="width_100"
                                placeholder="select one group"
                                loading={this.state.loading}
                                allowClear={true}
                                showSearch
                                value={this.state.batch_update_params.groupName}
                                onChange={(value) => this.setStateParams(this.state.batch_update_params, 'groupName', value)}>
                            {this.state.groupList.map(item => (
                                <Option key={item}>{item}</Option>
                            ))}
                        </Select>
                        <Input className="width_100 mt_10"
                               placeholder={'input new group name'}
                               value={this.state.batch_update_params.groupName}
                               onChange={(event) =>
                                   this.setStateParams(this.state.batch_update_params, 'groupName', event.target.value)
                               }>
                        </Input>
                    </div>
                </Modal>

                <Modal
                    title="Update Vthreads"
                    visible={this.state.showUpdateVthreadsModal}
                    onCancel={() => this.setState({showUpdateVthreadsModal: false})}
                    onOk={() => this.updateServerVthreads()}
                    confirmLoading={this.state.confirmLoading}
                    okText="OK"
                    cancelText="Cancel">
                    <div style={{height: 300, textAlign: 'center'}}>
                        <Input className="width_100 mt_10"
                               placeholder={'vthreads'}
                               value={this.state.batch_update_params.vthreads}
                               onChange={(event) =>
                                   this.setStateParams(this.state.batch_update_params, 'vthreads', event.target.value)
                               }>
                        </Input>
                    </div>
                </Modal>


                <Modal
                    closable={false}
                    keyboard={false}
                    maskClosable={false}
                    destroyOnClose={true}
                    width={1270}
                    style={{top: 50}}
                    visible={this.state.showEditModal}
                    onCancel={() => this.setState({showEditModal: false})}
                    onOk={() => this.saveOrUpdateRecord()}
                    confirmLoading={this.state.confirmLoading}
                    okText="Save"
                    cancelText="Cancel">

                    <div className={styles.from_container}>
                        <fieldset className={styles.fieldset_common}>
                            <div className={styles.legend}>WCN</div>
                            <Tag color="cyan" className="proxy_tag_label">network type</Tag>
                            <Select className="proxy_input"
                                    placeholder="select network type"
                                    value={this.state.form_params.networkType}
                                    onChange={(value) => this.handleFormSelectChange('networkType', value)}>
                                {this.state.networkTypeList.map(item => (
                                    <Option key={item.value}>{item.key}</Option>
                                ))}
                            </Select>
                            <Tag color="cyan" className="proxy_tag_label">provider</Tag>
                            <Select className="proxy_input mt_8"
                                    placeholder="select provider"
                                    value={this.state.form_params.provider}
                                    onChange={(value) => this.handleFormSelectChange('provider', value)}>
                                {this.state.providers.map(item => (
                                    <Option key={item}>{item}</Option>
                                ))}
                            </Select>
                            <Tag color="cyan" className="proxy_tag_label">cost tier</Tag>
                            <Select className="proxy_input mt_8"
                                    placeholder="select cost tier"
                                    value={this.normalizeCostTier(this.state.form_params.costTier)}
                                    onChange={(value) => this.handleFormSelectChange('costTier', value)}>
                                {costTierList.map(item => (
                                    <Option key={item.value} value={item.value}>{item.label}</Option>
                                ))}
                            </Select>
                            <Tag color="cyan" className="proxy_tag_label">country code</Tag>
                            <Select className="proxy_input mt_8"
                                    placeholder="select country"
                                    showSearch
                                    value={this.state.form_params.country_code}
                                    onChange={(value) => {
                                        this.handleFormSelectChange('country_code', value);
                                        this.loadCountryDetail(value);
                                    }}>
                                {this.state.serverLocationList.map(item => (
                                    <Option key={item.countryCode}>{item.countryName}</Option>
                                ))}
                            </Select>
                            <Tag color="cyan" className="proxy_tag_label">continent code</Tag>
                            <Input name={'continent_code'} placeholder={'continent code'}
                                   className="mt_8 proxy_input"
                                   value={this.state.form_params.continent_code}
                                   onChange={this.handleFormInputChange.bind(this)}
                                   onFocus={this.handleInputFocus.bind(this)}/>
                            <Tag color="cyan" className="proxy_tag_label">country name</Tag>
                            <Input name={'country_name'} placeholder={'country name'}
                                   className="mt_8 proxy_input"
                                   value={this.state.form_params.country_name}
                                   onChange={this.handleFormInputChange.bind(this)}
                                   onFocus={this.handleInputFocus.bind(this)}/>
                            <Tag color="cyan" className="proxy_tag_label">country code</Tag>
                            <Input name={'country_code'} placeholder={'country code'}
                                   className="mt_8 proxy_input"
                                   value={this.state.form_params.country_code}
                                   onChange={this.handleFormInputChange.bind(this)}
                                   onFocus={this.handleInputFocus.bind(this)}/>
                            <Tag color="cyan" className="proxy_tag_label">location</Tag>
                            <Input name={'location'} placeholder={'location'}
                                   className="mt_8 proxy_input"
                                   value={this.state.form_params.location}
                                   onChange={this.handleFormInputChange.bind(this)}
                                   onFocus={this.handleInputFocus.bind(this)}/>
                            <Tag color="cyan" className="proxy_tag_label">host</Tag>
                            <Input name={'host'} placeholder={'host'}
                                   className="mt_8 proxy_input"
                                   value={this.state.form_params.host}
                                   onChange={this.handleFormInputChange.bind(this)}
                                   onFocus={this.handleInputFocus.bind(this)}/>
                            <Tag color="cyan" className="proxy_tag_label">nh_port</Tag>
                            <Input name={'nh_port'} placeholder={'nh_port'}
                                   className="mt_8 proxy_input"
                                   value={this.state.form_params.nh_port}
                                   onChange={this.handleFormInputChange.bind(this)}
                                   onFocus={this.handleInputFocus.bind(this)}/>
                            <Tag color="cyan" className="proxy_tag_label">vthreads</Tag>
                            <Input name={'vthreads'} placeholder={'vthreads'}
                                   className="mt_8 proxy_input"
                                   value={this.state.form_params.vthreads}
                                   onChange={this.handleFormInputChange.bind(this)}
                                   onFocus={this.handleInputFocus.bind(this)}/>
                            <Tag color="cyan" className="proxy_tag_label">deny_countries</Tag>
                            <Input name={'deny_country_list'} placeholder={'deny_country_list'}
                                   className="mt_8 proxy_input"
                                   value={this.state.form_params.deny_country_list}
                                   onChange={this.handleFormInputChange.bind(this)}
                                   onFocus={this.handleInputFocus.bind(this)}/>
                            <Tag color="cyan" className="proxy_tag_label">remarks</Tag>
                            <Input name={'remarks'} rows={1} placeholder={'remarks'}
                                   className="mt_8 proxy_input"
                                   value={this.state.form_params.remarks}
                                   onChange={this.handleFormInputChange.bind(this)}/>
                        </fieldset>

                        <fieldset className={styles.fieldset_shadowsocks}>
                            <div className={styles.legend}>Trojan</div>
                            <Tag color="cyan" className="proxy_tag_label">trojan_domain</Tag>
                            <Input name={'trojan_domain'} placeholder={'trojan_domain'}
                                   className="proxy_input"
                                   value={this.state.form_params.trojan_domain}
                                   onChange={this.handleFormInputChange.bind(this)}
                                   onFocus={this.handleInputFocus.bind(this)}/>
                            <Tag color="cyan" className="proxy_tag_label">trojan_port</Tag>
                            <Input name={'trojan_port'} placeholder={'trojan_port'}
                                   className="mt_8 proxy_input"
                                   value={this.state.form_params.trojan_port}
                                   onChange={this.handleFormInputChange.bind(this)}
                                   onFocus={this.handleInputFocus.bind(this)}/>
                            <Tag color="cyan" className="proxy_tag_label" style={{marginTop: 15}}>trojan_password</Tag>
                            <Input name={'trojan_password'} placeholder={'trojan_password'}
                                   className="mt_8 proxy_input"
                                   value={this.state.form_params.trojan_password}
                                   addonAfter={
                                       <Icon type="reload" onClick={() => {
                                           let form_params = this.state.form_params;
                                           if (form_params.trojan_password) {
                                               form_params.trojan_password = CommonUtils.shuffleString(form_params.trojan_password);
                                               this.setState({
                                                   form_params: form_params
                                               });
                                           }
                                       }}/>
                                   }
                                   onChange={this.handleFormInputChange.bind(this)}
                                   onFocus={this.handleInputFocus.bind(this)}/>
                            <Tag color="cyan" className="proxy_tag_label">remote_addr</Tag>
                            <Input name={'trojan_remote_addr'} placeholder={'trojan_remote_addr'}
                                   className="mt_8 proxy_input"
                                   value={this.state.form_params.trojan_remote_addr}
                                   onChange={this.handleFormInputChange.bind(this)}
                                   onFocus={this.handleInputFocus.bind(this)}/>
                            <Tag color="cyan" className="proxy_tag_label">remote_port</Tag>
                            <Input name={'trojan_remote_port'} placeholder={'trojan_remote_port'}
                                   className="mt_8 proxy_input"
                                   value={this.state.form_params.trojan_remote_port}
                                   onChange={this.handleFormInputChange.bind(this)}
                                   onFocus={this.handleInputFocus.bind(this)}/>
                            <Tag color="cyan" className="proxy_tag_label">encryption_method</Tag>
                            <Input name={'trojan_encryption_method'} placeholder={'trojan_encryption_method'}
                                   className="mt_8 proxy_input"
                                   value={this.state.form_params.trojan_encryption_method}
                                   onChange={this.handleFormInputChange.bind(this)}
                                   onFocus={this.handleInputFocus.bind(this)}/>
                            <Tag color="cyan" className="proxy_tag_label" style={{marginTop: 15}}>encryption_password</Tag>
                            <Input name={'trojan_encryption_password'} placeholder={'trojan_encryption_password'}
                                   className="mt_8 proxy_input"
                                   value={this.state.form_params.trojan_encryption_password}
                                   addonAfter={
                                       <Icon type="reload" onClick={() => {
                                           let form_params = this.state.form_params;
                                           if (form_params.trojan_encryption_password) {
                                               form_params.trojan_encryption_password = CommonUtils.shuffleString(form_params.trojan_encryption_password);
                                               this.setState({
                                                   form_params: form_params
                                               });
                                           }
                                       }}/>
                                   }
                                   onChange={this.handleFormInputChange.bind(this)}
                                   onFocus={this.handleInputFocus.bind(this)}/>
                            <div className={'mt_10 ' + styles.divider_container}>
                                <Divider type="horizontal" style={{margin: '20px 10px 0px 0'}}/>
                            </div>

                            <fieldset className={styles.fieldset_shadowsocks_inner}>
                                <div className={styles.legend}>Shadowsocks</div>
                                <Tag color="cyan" className="proxy_tag_label">ps_host</Tag>
                                <Input name={'ps_host'} placeholder={'ps_host'}
                                       className="proxy_input"
                                       value={this.state.form_params.ps_host}
                                       onChange={this.handleFormInputChange.bind(this)}
                                       onFocus={this.handleInputFocus.bind(this)}/>
                                <Tag color="cyan" className="proxy_tag_label">ps_port</Tag>
                                <Input name={'ps_port'} placeholder={'ps_port'}
                                       className="mt_8 proxy_input"
                                       type="number"
                                       value={this.state.form_params.ps_port}
                                       onChange={this.handleFormInputChange.bind(this)}
                                       onFocus={this.handleInputFocus.bind(this)}/>
                                <Tag color="cyan" className="proxy_tag_label">ps_encryption</Tag>
                                <Input name={'ps_encryption'} placeholder={'ps_encryption'}
                                       className="mt_8 proxy_input"
                                       value={this.state.form_params.ps_encryption}
                                       onChange={this.handleFormInputChange.bind(this)}
                                       onFocus={this.handleInputFocus.bind(this)}/>
                                <Tag color="cyan" className="proxy_tag_label" style={{marginTop: 15}}>ps_password</Tag>
                                <Input name={'ps_password'} placeholder={'ps_password'}
                                       className="mt_8 proxy_input"
                                       value={this.state.form_params.ps_password}
                                       addonAfter={
                                           <Icon type="reload" onClick={() => {
                                               let form_params = this.state.form_params;
                                               form_params.ps_password = CommonUtils.shuffleString(form_params.ps_password);
                                               this.setState({
                                                   form_params: form_params
                                               });
                                           }}/>
                                       }
                                       onChange={this.handleFormInputChange.bind(this)}
                                       onFocus={this.handleInputFocus.bind(this)}/>
                            </fieldset>
                        </fieldset>

                        <fieldset className={styles.fieldset_trojan}>
                            <div className={styles.legend}>Vless</div>
                            <Tag color="cyan" className="proxy_tag_label">vless_port</Tag>
                            <Input name={'vless_port'} placeholder={'vless_port'}
                                   className="proxy_input"
                                   value={this.state.form_params.vless_port}
                                   onChange={this.handleFormInputChange.bind(this)}
                                   onFocus={this.handleInputFocus.bind(this)}/>
                            <Tag color="cyan" className="proxy_tag_label">vless_server_name</Tag>
                            <Input name={'vless_server_name'} placeholder={'vless_server_name'}
                                   className="mt_8 proxy_input"
                                   value={this.state.form_params.vless_server_name}
                                   onChange={this.handleFormInputChange.bind(this)}
                                   onFocus={this.handleInputFocus.bind(this)}/>
                            <Tag color="cyan" className="proxy_tag_label" style={{marginTop: 15}}>vless_uuid</Tag>
                            <Input name={'vless_uuid'} placeholder={'vless_uuid'}
                                   className="mt_8 proxy_input"
                                   value={this.state.form_params.vless_uuid}
                                   addonAfter={
                                       <Icon type="reload" onClick={this.generateVlessUuid.bind(this)}/>
                                   }
                                   onChange={this.handleFormInputChange.bind(this)}
                                   onFocus={this.handleInputFocus.bind(this)}/>
                            <Tag color="cyan" className="proxy_tag_label" style={{marginTop: 15}}>reality_private_key</Tag>
                            <Input name={'vless_reality_private_key'} placeholder={'vless_reality_private_key'}
                                   className="mt_8 proxy_input"
                                   value={this.state.form_params.vless_reality_private_key}
                                   addonAfter={
                                       <Icon type="reload" onClick={this.generateVlessRealityKeyPair.bind(this)}/>
                                   }
                                   onChange={this.handleFormInputChange.bind(this)}
                                   onFocus={this.handleInputFocus.bind(this)}/>
                            <Tag color="cyan" className="proxy_tag_label">reality_public_key</Tag>
                            <Input name={'vless_reality_public_key'} placeholder={'vless_reality_public_key'}
                                   className="mt_8 proxy_input"
                                   value={this.state.form_params.vless_reality_public_key}
                                   readOnly
                                   onFocus={this.handleInputFocus.bind(this)}/>
                            <Tag color="cyan" className="proxy_tag_label" style={{marginTop: 15}}>reality_short_id</Tag>
                            <Input name={'vless_reality_short_id'} placeholder={'vless_reality_short_id'}
                                   className="mt_8 proxy_input"
                                   value={this.state.form_params.vless_reality_short_id}
                                   addonAfter={
                                       <Icon type="reload" onClick={this.generateVlessRealityShortId.bind(this)}/>
                                   }
                                   onChange={this.handleFormInputChange.bind(this)}
                                   onFocus={this.handleInputFocus.bind(this)}/>
                            <div className={'mt_10 ' + styles.divider_container}>
                                <Divider type="horizontal" style={{margin: '20px 10px 0px 0'}}/>
                            </div>
                            <div className={styles.option_container}>
                                <Row>
                                    <Col span={24}>
                                        <Checkbox.Group value={this.state.form_params.offered_protocols ?
                                            this.normalizeOfferedProtocols(this.state.form_params.offered_protocols).split(',') : []}
                                                        onChange={this.handleOfferedProtocolsChange.bind(this)}>
                                            <div color="cyan" className={styles.option}>Protocols:</div>
                                            <Checkbox value="tun" className={styles.protocol_option}>Tun</Checkbox>
                                            <Checkbox value="vless" className={styles.protocol_option}>Vless</Checkbox>
                                            <Checkbox value="trojan" className={styles.protocol_option}>Trojan</Checkbox>
                                            <Checkbox value="trojan-go" className={styles.protocol_option}>Trojan-Go</Checkbox>
                                            <Checkbox value="ss" className={styles.protocol_option}>Shadowsocks</Checkbox>
                                        </Checkbox.Group>
                                    </Col>
                                </Row>
                            </div>
                        </fieldset>
                    </div>
                </Modal>

                <Modal
                    title="Server Details"
                    width={1270}
                    style={{top: 50}}
                    footer={null}
                    visible={this.state.showServerDetailDialog}
                    onCancel={() => this.setState({showServerDetailDialog: false})}>
                    <div className={styles.from_container}>
                        <fieldset className={styles.fieldset_common}>
                            <div className={styles.legend}>WCN</div>
                            <div className="mt_10"><Tag color="cyan">network type:</Tag> {this.state.selectedRow.networkTypeText}</div>
                            <div className="mt_10"><Tag color="cyan">provider:</Tag> {this.state.selectedRow.provider}</div>
                            <div className="mt_10"><Tag color="cyan">cost tier:</Tag> {this.renderCostTier(this.state.selectedRow.costTier)}</div>
                            <div className="mt_10"><Tag color="cyan">Node ID:</Tag> {this.state.selectedRow.nodeId}</div>
                            <div className="mt_10"><Tag color="cyan">continent code:</Tag> {this.state.selectedRow.continent_code}</div>
                            <div className="mt_10"><Tag color="cyan">country code:</Tag> {this.state.selectedRow.country_code}</div>
                            <div className="mt_10"><Tag color="cyan">country name:</Tag> {this.state.selectedRow.country_name}</div>
                            <div className="mt_10"><Tag color="cyan">location:</Tag> {this.state.selectedRow.location}</div>
                            <div className="mt_10"><Tag color="cyan">host:</Tag> {this.state.selectedRow.host}</div>
                            <div className="mt_10"><Tag color="cyan">nh_port:</Tag> {this.state.selectedRow.nh_port}</div>
                            <div className="mt_10"><Tag color="cyan">vthreads:</Tag> {this.state.selectedRow.vthreads}</div>
                            <div className="mt_10"><Tag color="cyan">offered_protocols:</Tag> {this.state.selectedRow.offered_protocols}</div>
                            <div className="mt_10"><Tag color="cyan">deny_country_list:</Tag> {this.state.selectedRow.deny_country_list}</div>
                            <div className="mt_10"><Tag color="cyan">status:</Tag> {this.state.selectedRow.statusText}</div>
                            <div className="mt_10"><Tag color="cyan">Remarks:</Tag> {this.state.selectedRow.remarks}</div>
                        </fieldset>
                        <fieldset className={styles.fieldset_shadowsocks}>
                            <div className={styles.legend}>Trojan</div>
                            <div className="mt_10"><Tag color="cyan">trojan_domain:</Tag> {this.state.selectedRow.trojan_domain}</div>
                            <div className="mt_10"><Tag color="cyan">trojan_port:</Tag> {this.state.selectedRow.trojan_port}</div>
                            <div className="mt_10"><Tag color="cyan">trojan_password:</Tag> {this.state.selectedRow.trojan_password}</div>
                            <div className="mt_10"><Tag color="cyan">trojan_remote_addr:</Tag> {this.state.selectedRow.trojan_remote_addr}</div>
                            <div className="mt_10"><Tag color="cyan">trojan_remote_port:</Tag> {this.state.selectedRow.trojan_remote_port}</div>
                            <div className="mt_10"><Tag color="cyan">trojan_encryption_method:</Tag> {this.state.selectedRow.trojan_encryption_method}</div>
                            <div className="mt_10"><Tag color="cyan">trojan_encryption_password:</Tag> {this.state.selectedRow.trojan_encryption_password}</div>

                            <fieldset className={styles.fieldset_shadowsocks_inner}>
                                <div className={styles.legend}>Shadowsocks</div>
                                <div className="mt_10"><Tag color="cyan">ps_host:</Tag> {this.state.selectedRow.ps_host}</div>
                                <div className="mt_10"><Tag color="cyan">ps_port:</Tag> {this.state.selectedRow.ps_port}</div>
                                <div className="mt_10"><Tag color="cyan">ps_password:</Tag> {this.state.selectedRow.ps_password}</div>
                                <div className="mt_10"><Tag color="cyan">ps_encryption:</Tag> {this.state.selectedRow.ps_encryption}</div>
                            </fieldset>
                        </fieldset>
                        <fieldset className={styles.fieldset_trojan}>
                            <div className={styles.legend}>Vless</div>
                            <div className="mt_10"><Tag color="cyan">vless_port:</Tag> {this.state.selectedRow.vless_port}</div>
                            <div className="mt_10"><Tag color="cyan">vless_server_name:</Tag> {this.state.selectedRow.vless_server_name}</div>
                            <div className="mt_10"><Tag color="cyan">vless_uuid:</Tag> {this.state.selectedRow.vless_uuid}</div>
                            <div className="mt_10"><Tag color="cyan">vless_reality_private_key:</Tag> {this.state.selectedRow.vless_reality_private_key}</div>
                            <div className="mt_10"><Tag color="cyan">vless_reality_public_key:</Tag> {this.state.selectedRow.vless_reality_public_key}</div>
                            <div className="mt_10"><Tag color="cyan">vless_reality_short_id:</Tag> {this.state.selectedRow.vless_reality_short_id}</div>
                        </fieldset>
                    </div>
                </Modal>
            </div>
        )
    }

    startAddNewServer = () => {
        /*let form_params = this.state.form_params;

        // reset value
        delete form_params.networkType;
        delete form_params.provider;
        delete form_params.continent_code;
        delete form_params.country_code;
        delete form_params.country_name;
        delete form_params.location;
        delete form_params.host;
        delete form_params.ps_host;
        delete form_params.remarks;*/

        let parameters = {
            nh_port: this.state.proxyServerConfig.nh_port,
            vthreads: this.state.proxyServerConfig.vthreads,
            costTier: COST_TIER_STANDARD,
            ps_port: this.state.proxyServerConfig.ps_port,
            ps_password: this.state.proxyServerConfig.ps_password,
            ps_encryption: this.state.proxyServerConfig.ps_encryption,
            trojan_port: this.state.proxyServerConfig.trojan_port,
            trojan_password: this.state.proxyServerConfig.ps_password,
            trojan_remote_addr: this.state.proxyServerConfig.trojan_remote_addr,
            trojan_remote_port: this.state.proxyServerConfig.trojan_remote_port,
            trojan_encryption_method: this.state.proxyServerConfig.trojan_encryption_method,
            trojan_encryption_password: this.state.proxyServerConfig.ps_password,
            vless_port: this.state.proxyServerConfig.vless_port,
            vless_server_name: this.state.proxyServerConfig.vless_server_name,
            vless_uuid: this.state.proxyServerConfig.vless_uuid,
            vless_reality_private_key: this.state.proxyServerConfig.vless_reality_private_key,
            vless_reality_public_key: this.state.proxyServerConfig.vless_reality_public_key,
            vless_reality_short_id: this.state.proxyServerConfig.vless_reality_short_id,
            addFlag: true   // create flag
        };

        this.setState({
            showEditModal: true,
            selectedRow: {},
            form_params: parameters
        });

        console.debug('form_params = '+JSON.stringify(this.state.form_params))
    };

    startUpdateStatus = () => {
        let {selectedRowKeys} = this.state;
        if (selectedRowKeys !== '' && selectedRowKeys.length > 0) {
            let ids = selectedRowKeys.toString().split(",");
            this.setStateParams(this.state.batch_update_params, 'ids', ids);

            delete this.state.batch_update_params.status;   // reset status value

            this.setState({showBatchUpdateModal: true});
        } else {
            message.warn('Please select at least one record.');
        }
    };

    startAddNewGroup = () => {
        let {selectedRowKeys} = this.state;
        if (selectedRowKeys !== '' && selectedRowKeys.length > 0) {
            let ids = selectedRowKeys.toString().split(",");
            this.setStateParams(this.state.batch_update_params, 'ids', ids);

            delete this.state.batch_update_params.groupName;   // reset groupName value

            this.setState({showCreateGroupModal: true});
        } else {
            message.warn('Please select at least one record.');
        }

        this.loadGroupList();
    };

    startAddNewVthreads = () => {
        let {selectedRowKeys} = this.state;
        if (selectedRowKeys !== '' && selectedRowKeys.length > 0) {
            let ids = selectedRowKeys.toString().split(",");
            this.setStateParams(this.state.batch_update_params, 'ids', ids);

            delete this.state.batch_update_params.vthreads;   // reset groupName value

            this.setState({showUpdateVthreadsModal: true});
        } else {
            message.warn('Please select at least one record.');
        }

        this.loadGroupList();
    };

    isEmptyFormValue(value) {
        return typeof value === 'undefined' || value === null || value === '';
    }

    updateFormParams(values) {
        let form_params = this.state.form_params;
        Object.assign(form_params, values);
        this.setState({form_params: form_params});
    }

    generateVlessUuid() {
        this.updateFormParams({vless_uuid: uuidv4()});
    }

    getSecureCrypto() {
        return window.crypto || window.msCrypto;
    }

    generateRandomHex(byteLength) {
        let crypto = this.getSecureCrypto();
        if (!crypto || !crypto.getRandomValues) {
            throw new Error('Secure random generator is unavailable');
        }
        let bytes = new Uint8Array(byteLength);
        crypto.getRandomValues(bytes);
        return Array.from(bytes)
            .map(byte => ('0' + byte.toString(16)).slice(-2))
            .join('');
    }

    generateVlessRealityShortId() {
        try {
            this.updateFormParams({vless_reality_short_id: this.generateRandomHex(8)});
        } catch (err) {
            console.error(err);
            message.error('Secure random generator is unavailable.');
        }
    }

    async generateVlessRealityKeyPair() {
        let crypto = this.getSecureCrypto();
        if (!crypto || !crypto.subtle || !crypto.subtle.generateKey) {
            message.error('Current browser does not support X25519 key generation.');
            return;
        }

        try {
            let keyPair = await crypto.subtle.generateKey({name: 'X25519'}, true, ['deriveBits']);
            let publicKey = await crypto.subtle.exportKey('jwk', keyPair.publicKey);
            let privateKey = await crypto.subtle.exportKey('jwk', keyPair.privateKey);
            if (!publicKey.x || !privateKey.d) {
                message.error('Current browser cannot export X25519 Reality keys.');
                return;
            }

            let form_params = this.state.form_params;
            let values = {
                vless_reality_private_key: privateKey.d,
                vless_reality_public_key: publicKey.x
            };
            if (this.isEmptyFormValue(form_params.vless_reality_short_id)) {
                values.vless_reality_short_id = this.generateRandomHex(8);
            }
            this.updateFormParams(values);
        } catch (err) {
            console.error(err);
            message.error('Current browser cannot generate X25519 Reality keys.');
        }
    }

    handleOfferedProtocolsChange(value) {
        let selectedProtocols = value ? value.slice() : [];
        let currentProtocols = this.state.form_params.offered_protocols ?
            this.state.form_params.offered_protocols.split(',') : [];

        if (selectedProtocols.indexOf('trojan') >= 0 && selectedProtocols.indexOf('trojan-go') >= 0) {
            if (currentProtocols.indexOf('trojan') < 0) {
                selectedProtocols = selectedProtocols.filter(protocol => protocol !== 'trojan-go');
            } else if (currentProtocols.indexOf('trojan-go') < 0) {
                selectedProtocols = selectedProtocols.filter(protocol => protocol !== 'trojan');
            } else {
                selectedProtocols = selectedProtocols.filter(protocol => protocol !== 'trojan-go');
            }
        }

        this.handleFormSelectChange('offered_protocols', selectedProtocols.toString());
    }

    normalizeOfferedProtocols(offered_protocols) {
        if (!offered_protocols) {
            return offered_protocols;
        }
        let hasTrojanProtocol = false;
        return offered_protocols.split(',')
            .filter(protocol => {
                if (protocol === 'wireguard') {
                    return false;
                }
                if (protocol === 'trojan' || protocol === 'trojan-go') {
                    if (hasTrojanProtocol) {
                        return false;
                    }
                    hasTrojanProtocol = true;
                }
                return true;
            })
            .toString();
    }

    buildModifyProxyServerParams(form_params) {
        let request_params = {};
        modifyProxyServerFields.forEach(field => {
            if (typeof form_params[field] !== 'undefined') {
                request_params[field] = form_params[field];
            }
        });
        request_params.offered_protocols = this.normalizeOfferedProtocols(request_params.offered_protocols);
        request_params.costTier = this.normalizeCostTier(request_params.costTier);
        return request_params;
    }

    saveOrUpdateRecord () {
        let form_params = this.state.form_params;

        if (form_params.offered_protocols) {
            let offered_protocols_array = form_params.offered_protocols.split(',');
            for (let i = 0; i < offered_protocols_array.length; i++) {
                if (offered_protocols_array[i] === 'ss') {
                    if (this.isEmptyFormValue(form_params.ps_host)
                        || this.isEmptyFormValue(form_params.ps_port)
                        || this.isEmptyFormValue(form_params.ps_password)
                        || this.isEmptyFormValue(form_params.ps_encryption)) {
                        message.warn('Shadowsocks parameters is incomplete!');
                        return false;
                    }
                } else if (offered_protocols_array[i] === 'trojan' || offered_protocols_array[i] === 'trojan-go') {
                    if (this.isEmptyFormValue(form_params.trojan_domain)
                        || this.isEmptyFormValue(form_params.trojan_port)
                        || this.isEmptyFormValue(form_params.trojan_password)
                        || this.isEmptyFormValue(form_params.trojan_remote_addr)
                        || this.isEmptyFormValue(form_params.trojan_remote_port)) {
                        message.warn('Trojan parameters is incomplete!');
                        return false;
                    }
                } else if (offered_protocols_array[i] === 'vless') {
                    if (this.isEmptyFormValue(form_params.vless_port)
                        || this.isEmptyFormValue(form_params.vless_uuid)
                        || this.isEmptyFormValue(form_params.vless_server_name)
                        || this.isEmptyFormValue(form_params.vless_reality_private_key)
                        || this.isEmptyFormValue(form_params.vless_reality_public_key)
                        || this.isEmptyFormValue(form_params.vless_reality_short_id)) {
                        message.warn('Vless parameters is incomplete!');
                        return false;
                    }
                }
            }
        }

        let request_params = this.buildModifyProxyServerParams(form_params);
        let costTierChanged = !form_params.addFlag
            && this.normalizeCostTier(this.state.selectedRow.costTier) !== this.normalizeCostTier(form_params.costTier);

        this.setState({ confirmLoading: true});
        new WebServerRestClient().POST('/admin/modify-proxy-server', request_params)
            .then(response => {
                console.log("modify-server-location response -> " + JSON.stringify(response));
                this.setState({confirmLoading: false});
                if (response.code === 200) {
                    this.setState({showEditModal: false});
                    if (costTierChanged) {
                        message.info('Cost tier saved. Rebuild cached nodes to apply it.');
                    }
                    this.loadListData();
                } else {
                    message.warn(response['msg']);
                }
            }).catch(err => {
            this.setState({confirmLoading: false});
            message.error("Error: " + err.message);
        });
    };

    batchUpdateServerStatus(){
        let batch_update_params = this.state.batch_update_params;
        if(batch_update_params.ids.length === 0){
            message.warn('Please select at least one record.');
            return;
        }
        if(batch_update_params.status === ''){
            message.warn('Please select a server status.');
            return;
        }

        if (batch_update_params.status === '5') {
            // delete operation
            let pageRef = this;
            confirm({
                title: 'Do you want to delete these nodes?',
                onOk() {
                    pageRef.processStatusUpdate(batch_update_params)
                }
            });
        } else {
            this.processStatusUpdate(batch_update_params)
        }
    }

    processStatusUpdate(batch_update_params) {
        this.setState({confirmLoading: true});
        new WebServerRestClient().POST('/admin/batch-update-server-status', batch_update_params)
            .then(response => {
                console.log("batch-update-server-status response -> " + JSON.stringify(response));
                this.setState({confirmLoading: false});
                if (response.code === 200) {
                    this.setState({showBatchUpdateModal: false});
                    this.loadListData();
                } else {
                    message.warn(response['msg']);
                }
            }).catch(err => {
            this.setState({confirmLoading: false});
            message.error("Error: " + err.message);
        });
    }

    addServerToGroup(){
        let batch_update_params = this.state.batch_update_params;
        if(batch_update_params.ids.length === 0){
            message.warn('Please select at least one record.');
            return;
        }
        if(batch_update_params.groupName === ''){
            message.warn('Please select a group.');
            return;
        }
        this.setState({ confirmLoading: true});
        new WebServerRestClient().POST('/admin/batch-update-server-group', batch_update_params)
            .then(response => {
                console.log("batch-update-server-group response -> " + JSON.stringify(response));
                this.setState({confirmLoading: false});
                if (response.code === 200) {
                    this.setState({showCreateGroupModal: false});
                    this.loadListData();
                    this.loadGroupList();
                } else {
                    message.warn(response['msg']);
                }
            }).catch(err => {
            this.setState({confirmLoading: false});
            message.error("Error: " + err.message);
        });
    }

    updateServerVthreads(){
        let batch_update_params = this.state.batch_update_params;
        if(batch_update_params.ids.length === 0){
            message.warn('Please select at least one record.');
            return;
        }
        if(batch_update_params.vthreads === ''){
            message.warn('Please input vthreads.');
            return;
        }
        this.setState({ confirmLoading: true});
        new WebServerRestClient().POST('/admin/batch-update-server-vthreads', batch_update_params)
            .then(response => {
                console.log("batch-update-server-vthreads response -> " + JSON.stringify(response));
                this.setState({confirmLoading: false});
                if (response.code === 200) {
                    this.setState({showUpdateVthreadsModal: false});
                    this.loadListData();
                    this.loadGroupList();
                } else {
                    message.warn(response['msg']);
                }
            }).catch(err => {
            this.setState({confirmLoading: false});
            message.error("Error: " + err.message);
        });
    }

}
